import { atomWithImmer } from "jotai-immer";

import type { ContactAddressModalState } from "../types";

export const initialContactAddressState: ContactAddressModalState = {
  isVisible: false,
  contactId: null,
  defaultPlace: "",
  createNew: true,
};

export const contactAddressModalAtom = atomWithImmer<ContactAddressModalState>(
  initialContactAddressState,
);
